export const apiPath = '/v2/type_accesses';
const actionType = 'ACCESSES';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
